import './App.css';
import Home from './pages/about';
import About from './pages/more';
import { Route, Routes, Link } from "react-router-dom";
import Footer from './components/footer';
import Contact from './pages/contact';
import { Analytics } from '@vercel/analytics/react';

function App() {
  return (
    <>
      <div className='bg-gradient-to-b from-zinc-900 to-purple-900/10'>
        <div className="grid lg:grid-cols-4 md:grid-cols-3 sm:grid-cols-3 min-h-screen ">
          <div className='lg:col-span-1 col-span-6 '>
            <div className='grid lg:grid-cols-1 grid-cols-3 mx-10 sticky top-0 lg:pt-5 lg:bg-transparent lg:border-transparent 
            bg-zinc-800 border border-zinc-700 rounded-xl my-4'>
              <div className='py-2 lg:text-left text-center  hover:underline underline-offset-8'>
                <Link to="/" className=' '>/</Link>
              </div>
              <div className='py-2 lg:text-left text-center '>
                <Link to="/about">about</Link>
              </div>
              <div className='py-2 lg:text-left text-center '>
                <Link to="/contact">contact</Link>
              </div>
            </div>
          </div>
          <div className='lg:col-span-2 md:col-span-3 sm:col-span-3 mx-auto lg:max-w-5xl md:max-w-2xl py-10 px-5'>
            <div>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/contact" element={<Contact />} />
              </Routes>
            </div>
          </div>
        </div>
      <Footer/>
    </div>
    <Analytics />
    </>
  );
}

export default App;
